const initialState = {
    addresses: [],
};
const addresses = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_USER_ADDRESSES':
            return {...state, [action.name]: action.value};
       	
        default:
            return state;
    }
};

export default addresses;
